import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexRating',
  setup(__props) {

const clickableValue = defineAsyncComponent(() => import("@/components/theme/advance/rating/clickableValue.vue"))
const movieRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/movieRating.vue"))
const heartRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/heartRating.vue"))
const starRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/starRating.vue"))
const disabledRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/disabledRating.vue"))
const animationRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/animationRating.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Rating"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(clickableValue)),
        _createVNode(_unref(movieRating)),
        _createVNode(_unref(heartRating)),
        _createVNode(_unref(starRating)),
        _createVNode(_unref(disabledRating)),
        _createVNode(_unref(animationRating))
      ])
    ])
  ], 64))
}
}

})